import type { KbEntry, KbSourceType } from '@/api/kb';

export interface SourceTypeMeta {
  label: string;
  /** Table chip classes (text + light bg). */
  colorClass: string;
  /** Card badge classes (stronger bg). */
  badgeClass: string;
}

const META: Record<KbSourceType, SourceTypeMeta> = {
  Qualitative: { label: 'Qualitative', colorClass: 'text-blue-600 bg-blue-50', badgeClass: 'bg-blue-100 text-blue-700' },
  Quantitative: { label: 'Quantitative', colorClass: 'text-purple-600 bg-purple-50', badgeClass: 'bg-purple-100 text-purple-700' },
  Attachment: { label: 'Attachment', colorClass: 'text-green-600 bg-green-50', badgeClass: 'bg-green-100 text-green-700' },
  Both: { label: 'Both', colorClass: 'text-teal-600 bg-teal-50', badgeClass: 'bg-teal-100 text-teal-700' },
  Exact: { label: 'Exact', colorClass: 'text-emerald-600 bg-emerald-50', badgeClass: 'bg-emerald-100 text-emerald-700' },
  VaultData: { label: 'Vault Data', colorClass: 'text-indigo-600 bg-indigo-50', badgeClass: 'bg-indigo-100 text-indigo-700' },
  Generated: { label: 'Generated', colorClass: 'text-amber-600 bg-amber-50', badgeClass: 'bg-amber-100 text-amber-700' },
};

const FALLBACK: SourceTypeMeta = {
  label: '',
  colorClass: 'text-gray-600 bg-gray-50',
  badgeClass: 'bg-gray-100 text-gray-700',
};

/** Display metadata for a source type; unknown values render the raw string. */
export function sourceTypeMeta(sourceType: string): SourceTypeMeta {
  return META[sourceType as KbSourceType] ?? { ...FALLBACK, label: sourceType };
}

/** Source types a human picks in the create form / filters. */
export const SELECTABLE_SOURCE_TYPES: Array<{
  value: KbSourceType;
  label: string;
  description: string;
}> = [
  { value: 'Qualitative', label: 'Qualitative', description: 'Narrative / prose answer' },
  { value: 'Quantitative', label: 'Quantitative', description: 'Numeric / data answer' },
  { value: 'Both', label: 'Both', description: 'Mixed narrative and data' },
  { value: 'Attachment', label: 'Attachment', description: 'Answer is an attached document' },
];

/** Backend returns no `is_firm_specific`; null/0 firm_id means global. */
export function isFirmSpecific(entry: Pick<KbEntry, 'firm_id'>): boolean {
  return entry.firm_id != null && entry.firm_id !== 0;
}
